<script>
export default {
  name: 'Services'
}
</script>

<template>
  <div>
    <!--START SERVICES-->
    <section class="section bg-light" id="services">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2">
            <h1 class="section-title text-center">Nuestros Servicios</h1>
            <div class="section-title-border margin-t-20"></div>
            <p
              class="section-subtitle text-muted text-center padding-t-30 font-secondary"
            >Creamos pensamiento digital, gráfico y dimensional, para crear experiencias tecnológicas líderes en su categoría que tengan significado y agreguen un valor para nuestros clientes y colaboradores.</p>
          </div>
        </div>
        <div class="row margin-t-30">
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-rocket text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Transformación digital & App Móvil</h4>
                  <p
                    class="pt-2 text-muted"
                  >Te ayudamos a afrontar los grandes retos tecnológicos de tu dia a dia, trabajando con herramientas  100% digitales, así como la creación de tu app móvil.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-display2 text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Capacitación tecnológica</h4>
                  <p
                    class="pt-2 text-muted"
                  >Estamos comprometidos con la innovación y capacitación constante de nuestros colaboradores.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-piggy text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Soluciones Financieras</h4>
                  <p
                    class="pt-2 text-muted"
                  >Contamos con soluciones financieras móviles y de negocio, las cuales ayudan a un mejor seguimiento de sus empleados en campo y en oficinas centrales, dando un mejor rendimiento y desempeño en ventas, como en cobranza.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-cloud text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Migraciones a la nube</h4>
                  <p
                    class="pt-2 text-muted"
                  >Nosotros estamos enfocados en ayudar a su compañía a reducir costos montando toda su infraestructura a la nube, logrando así estar a la altura de grandes empresas a un costo más bajo.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-smile text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Coach Scrum</h4>
                  <p
                    class="pt-2 text-muted"
                  >Estamos comprometidos con un enfoque ágil,  para ayudar a su empresa a optar por este marco de trabajo profesional, que le  ayudará a  todo su equipo a desarrollar software en conjunto  con de cualquier área, trabajando en un marco de referencia ágil siguiendo SCRUM y SaFe.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-gleam text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Software a la medida</h4>
                  <p
                    class="pt-2 text-muted"
                  >El reto más importante que tenemos con nuestros clientes es hacer de un sueño una realidad tangible en un software que logre sus objetivos y metas.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-joy text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Desarrollo de videojuegos</h4>
                  <p
                    class="pt-2 text-muted"
                  >Somos apasionados del entretenimiento, por ello llevamos a cabo el desarrollo de videojuegos como proyectos profesionales.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-comment text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Community Manager</h4>
                  <p
                    class="pt-2 text-muted"
                  >Enfocado a las empresas de hoy en día, que quieran mantenerse comunicados con sus clientes mediante sus medios de comunicación.  Lanzamos el servicio de community manager el cual generamos planes a la medida para el seguimiento de las redes sociales.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-look text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Inteligencia Artificial</h4>
                  <p
                    class="pt-2 text-muted"
                  >Contamos con gran variedad de proyectos los cuales manejamos IA, como chatbots, procesamiento inteligente de imagenes, analitica de datos, entre otros.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--START SERVICES-->

    <!--START WEBSITE-DESCRIPTION-->
    <section
      class="section bg-web-desc"
      :style="{'background-image': 'url(' + require('@/assets/images/background.jpg') + ')', 'background-size': 'cover','background-position': 'center'}"
    >
      <div class="bg-overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="text-white">Más de 5 años de experiencia</h2>
            <p
              class="padding-t-15 home-desc mx-auto"
            >Trabajamos para ser reconocidos y referidos por nuestra integridad,
            accesibilidad e innovación en el diseño y comercialización de experiencias digitales de <b>alta calidad</b> y <b>utilidad.</b></p>
            
          </div>
        </div>
      </div>
    </section>
    <!--END WEBSITE-DESCRIPTION-->
  </div>
</template>